import CommonModal from "../../UserScreen/InventoryPage/InventorySettings/components/Modals/CommonModal";
import "./EmailTab.css";
import email_send from "../../asset/image/email_send.svg";
import LabelValueDisplay from '../../UserScreen/InventoryPage/InventorySettings/components/LabelValue/LabelValueDisplay';
import email_success from "../../asset/image/email_success.svg";
import email_fail from "../../asset/image/email_fail.svg";
import alert_icon from "../../asset/image/alert_icon.svg";

interface SendgridTestmailDialogProps {
    sendTestemail: any;
    successFail: boolean;
    handleCancelSuccessFail: () => void;
    email: string;
    recMail: string;
}

const SendgridTestmailDialog = (props: SendgridTestmailDialogProps) => {
    const {sendTestemail, successFail, handleCancelSuccessFail, email, recMail} = props;

    const element = (
        <div className="padding10">
            {sendTestemail?.success == true && <img src={email_success} className="testmailStatusImage"></img>}
            {sendTestemail?.success == false && <img src={email_fail} className="testmailStatusImage"></img>}
            {sendTestemail?.success !== undefined && <div className="transfer-tab-grid">
                <LabelValueDisplay
                    label="From"
                    value={email}
                />
            </div>}
            {sendTestemail?.success && <LabelValueDisplay
                label="To"
                value={recMail}
            />}
            {sendTestemail?.success == true && <div className="successFailText">The email has been successfully sent.</div>}
            {sendTestemail?.success == false && <div className="successFailText">The email could not be sent. Please try again later.</div>}
        </div>
    )
    return(
        <CommonModal
            open={(sendTestemail?.success !== undefined) && successFail}
            onClose={handleCancelSuccessFail}
            onSave={handleCancelSuccessFail}
            title={"Test Email"}
            saveText={"OK"}
            showOnlineOffline={false}
            showSyncStatus={false}
            children={element}
            width={"408px"}
            height={"321px"}
            showCancel={false}
            titleWithWarningIcon={sendTestemail?.success == true}
            titleWithCustomIcon={sendTestemail?.success == false}
            customIcon={alert_icon}
        />
    )
}

export default SendgridTestmailDialog;